import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { host } from '../App';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import { Button, Menu, Dropdown, Row } from 'antd';
import { Link } from "react-router-dom";
import './New_cut.css'

function New_cut(props) {
  var token = (window.localStorage.getItem("acessToken"));
  const user = JSON.parse(window.localStorage.getItem("Name"));
  const [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [part_dataset, setpart_dataset] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [part_layout, setpart_layout] = useState([]);
  const [Sub_part_layout, setsub_part_layout] = useState([]);
  var length = 0;
  const [employees, setEmployees] = useState([]);
  const [Part_Number, setPart_Number] = useState({});

  const [data, setData] = useState([
    { SheetID: "", ItemNo: "", LotNo: "", ChairPartType: "", PartNumber: "", Dimensions: "", Quantity: "", CutDate: Date2, Operator: user, Status: "", Scrap: "", Remarks: "" },
    { SheetID: "", ItemNo: "", LotNo: "", ChairPartType: "", PartNumber: "", Dimensions: "", Quantity: "", CutDate: Date2, Operator: user, Status: "", Scrap: "", Remarks: "" },
    { SheetID: "", ItemNo: "", LotNo: "", ChairPartType: "", PartNumber: "", Dimensions: "", Quantity: "", CutDate: Date2, Operator: user, Status: "", Scrap: "", Remarks: "" },
    { SheetID: "", ItemNo: "", LotNo: "", ChairPartType: "", PartNumber: "", Dimensions: "", Quantity: "", CutDate: Date2, Operator: user, Status: "", Scrap: "", Remarks: "" },
    { SheetID: "", ItemNo: "", LotNo: "", ChairPartType: "", PartNumber: "", Dimensions: "", Quantity: "", CutDate: Date2, Operator: user, Status: "", Scrap: "", Remarks: "" },
  ]);

  const queryParams = {
    token: token,
    Part_Number: Part_Number,
  };


  // Hook to update the date as today's date
  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });

  useEffect(() => {
    Axios.get(`https://` + host + `/api/supplychain/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data);
    });
  }, []);
  useEffect(() => {
    Axios.get(`https://` + host + `/Woodshop/Part_layout`, { params: queryParams }).then((data) => {
      setpart_layout(data.data);
      console.log(data.data);
    });
  }, []);

  useEffect(() => {
    Axios.get(`https://` + host + `/Woodshop/Sub_Part_layout`, { params: queryParams }).then((data) => {
      setsub_part_layout(data.data);
    });
  }, []);
  useEffect(() => {
    Axios.get(`https://` + host + `/api/employees_all/${token}`).then((data) => {
      setEmployees(data.data);
    });
  }, []);

  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
  }, [Date2])

  let sheetIdCounter = 0;

  const generateNewSheetID = (itemNo) => {
    const now = new Date();
    // e.g. “20250421” for YYYYMMDD
    const datePart = now.toISOString().slice(0, 10).replace(/-/g, "");
    // e.g. “143512” for HHMMSS
    const timePart = now
      .toTimeString()          // "14:35:12 GMT‑... (…)”
      .slice(0, 8)             // "14:35:12"
      .replace(/:/g, "");      // "143512"
    // optional: millisecond precision, e.g. "143512123"
    const msPart = now.getMilliseconds().toString().padStart(3, "0");

    const newSheetID = `${datePart}${timePart}${msPart}-${itemNo}-${sheetIdCounter
      .toString()
      .padStart(3, "0")}`;

    sheetIdCounter += 1; // next call increments
    return newSheetID;
  };


  const submitValue = (e, index) => {
    const newData = [...data];
    newData[index].PartNumber = e.target.value;
    setPart_Number(e.target.value);
    newData[index].subParts = Sub_part_layout.filter(sub => sub.Parent_Part_No === e.target.value);

    newData[index].Sub_part_No = Sub_part_layout.filter(sub => sub.Parent_Part_No === e.target.value).Sub_part_No;
    newData[index].Sub_Part_Name = Sub_part_layout.filter(sub => sub.Parent_Part_No === e.target.value).Sub_Part_Name;

    // newData[index].LotNo = part_layout.find((x) => x.ITEM_NO === e.target.value).LOT_No;
    // newData[index].Part_Description = part_layout.find((x) => `${x.Woodshop_Part_No}` === e.target.value).Part_Name;
    newData[index].Dimensions = part_layout.find((x) => `${x.Part_Name}` === e.target.value).Size;
    newData[index].Customer = part_layout.find((x) => `${x.Part_Name}` === e.target.value).Customer;
    newData[index].LotNo = part_layout.find((x) => `${x.Part_Name}` === e.target.value).LOT_No;
    newData[index].ChairPartType = part_layout.find((x) => `${x.Part_Name}` === e.target.value).Category;
    newData[index].Required_Pcs = part_layout.find((x) => `${x.Part_Name}` === e.target.value).Required_Pcs;
    newData[index].ItemNo = part_layout.find((x) => `${x.Part_Name}` === e.target.value).Item_No;
    handleItemNoChange(part_layout.find((x) => `${x.Part_Name}` === e.target.value).Item_No, index)
    setData(newData);
  }

  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({ SheetID: "", ItemNo: "", LotNo: "", ChairPartType: "", PartNumber: "", Dimensions: "", Quantity: "", CutDate: Date2, Operator: user, Status: "", Scrap: "", Remarks: "" });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit");
    }
  };
  const handleItemNoChange = (value, index) => {
    const newData = [...data];
    if (!newData[index].SheetID) {
      // Generate a new Sheet ID only if one doesn't exist
      newData[index].SheetID = generateNewSheetID(value);
    }
    newData[index].ItemNo = value;
    setData(newData);
  };

  const handleMoreCut = (index) => {
    const newData = [...data];
    const currentRow = newData[index];
    newData.splice(index + 1, 0, {
      SheetID: currentRow.SheetID, // Reuse the same Sheet ID
      ItemNo: currentRow.ItemNo,  // Reuse the same Item No
      LotNo: "",
      ChairPartType: "",
      PartNumber: "",
      Dimensions: "",
      Quantity: "",
      CutDate: "",
      Operator: user,
      Status: "",
      Scrap: "",
      Remarks: "",
    });
    setData(newData);
  };

  const handleLogout = () => {
    window.localStorage.removeItem("acessToken");
    window.localStorage.removeItem("Name");
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    props.history.push('/');
  }
  const userMenu = (
    <Menu>
      <Menu.Item key="logout">
        <a onClick={handleLogout} href="/">
          <LogoutOutlined />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  const submitdata = () => {
    const filteredData = [];
    data.forEach(item => {
      if (item.PartNumber && item.CutDate && item.Operator) {
        const commonFields = {
          SheetID: item.SheetID,
          ItemNo: item.ItemNo,
          LotNo: item.LotNo,
          ChairPartType: item.ChairPartType,
          Dimensions: item.Dimensions,
          PartNumber: item.PartNumber,
          CutDate: item.CutDate,
          Operator: item.Operator,
          Status: item.Status,
          Scrap: item.Scrap,
          Remarks: item.Remarks,
        };
        if (item.subParts && Array.isArray(item.subParts)) {
          item.subParts.forEach(sub => {
            filteredData.push({
              ...commonFields,
              Sub_part_No: sub.Sub_part_No,
              Sub_Part_Name: sub.Sub_Part_Name,
              Status: sub.subStatus,
              Quantity: sub.subQTY,
              Scrap: sub.subScrap,
              Remarks: sub.subRemarks
            });
          });
        }
      }
    });
    const finalDataToSend = filteredData.map(row => [
      row.SheetID,
      row.ItemNo,
      row.LotNo,
      row.ChairPartType,
      row.PartNumber,
      row.Dimensions,
      row.CutDate,
      row.Operator,
      row.Status,
      row.Scrap,
      row.Remarks,
      row.Sub_part_No,
      row.Sub_Part_Name,
      row.Quantity,
      user
    ]);
    setIsLoading(true);
    setTimeout(() => {
      Axios.post(`https://` + host + `/woodshop/unfinishedParts`, { finalDataToSend })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            setIsLoading(false);
            window.location.reload();
          }
        })
        .catch(error => {
          window.alert("Error Occured")
          setIsLoading(false);
        });
    }, 2000);
    // window.location.reload(false);
  }

  const print = () => {
    console.log(data);
    const filteredData = [];
    data.forEach(item => {
      if (item.PartNumber && item.CutDate && item.Operator) {
        const commonFields = {
          SheetID: item.SheetID,
          ItemNo: item.ItemNo,
          LotNo: item.LotNo,
          ChairPartType: item.ChairPartType,
          Dimensions: item.Dimensions,
          PartNumber: item.PartNumber,
          CutDate: item.CutDate,
          Operator: item.Operator,
          //     Status: item.Status,
          //      Scrap: item.Scrap,
          //      Remarks: item.Remarks,
        };

        if (item.subParts && Array.isArray(item.subParts)) {
          item.subParts.forEach(sub => {
            filteredData.push({
              ...commonFields,
              Sub_part_No: sub.Sub_part_No,
              Sub_Part_Name: sub.Sub_Part_Name,
              Status: sub.subStatus,
              Quantity: sub.subQTY,
              Remarks: sub.subRemarks
            });
          });
        }
      }
    });

    console.log(filteredData);
  };
  return (
    <div>
      <br></br>
      <button onClick={addLines} class="btn btn-success">Add Row</button>
      <br></br>
      <br></br>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th hidden>Sheet ID</th>
            <th hidden>Item No</th>
            <th>Lot No</th>
            <th hidden>Chair Part Type</th>
            <th>Part Number</th>
            <th>Sheet Type</th>
            <th>Quantity</th>
            <th>Cut Date</th>
            <th>Operator</th>
            <th>Status</th>
            <th>Scrap</th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <React.Fragment key={index}>
              <tr key={index} className={`parent-row ${row.subParts ? "selected" : ""}`}>
                <td hidden>{row.SheetID || "Auto-Generated"}</td>
                <td hidden>
                  <input
                    type="text"
                    className="form-control"
                    Value={row.ItemNo}
                    placeholder="Enter Item No"
                    readOnly
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={row.LotNo}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].LotNo = e.target.value;
                      setData(newData);
                    }}
                    placeholder="Enter Lot No"
                    readOnly
                  />
                </td>
                <td hidden>
                  <input
                    type="text"
                    className="form-control"
                    value={row.ChairPartType}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].ChairPartType = e.target.value;
                      setData(newData);
                    }}
                    placeholder="Enter Chair Part Type"
                  />
                </td>
                <td>
                  <select name="PartNo" class="form-control" placeholder="Select Part " onChange={(e) => {
                    const newData = [...data];
                    newData[index].PartNumber = e.target.value;
                    setData(newData);
                  }}
                    onBlur={(e) => submitValue(e, index)}>
                    <option value="">Select Part No</option>
                    {part_layout.map((x) => (
                      <option key={x.Part_Name} value={x.Part_Name}>
                        {x.Part_Name}
                      </option>
                    ))}
                  </select>
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={row.Dimensions}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].Dimensions = e.target.value;
                      setData(newData);
                    }}
                    placeholder="Enter Dimensions"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    value={row.Quantity}
                    onChange={(e) => {

                      const newData = [...data];
                      newData[index].Quantity = e.target.value;
                      setData(newData);
                      for (var i = 0; i < row.subParts.length; i++) {
                        const newData = [...data];
                        newData[index].subParts[i].subQTY = e.target.value;
                        setData(newData);
                      }

                    }}
                    placeholder="Enter Quantity"
                  //  readOnly={row.subParts && row.subParts.length > 0}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={row.CutDate}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].CutDate = e.target.value;
                      setData(newData);
                    }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={row.Operator}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].Operator = e.target.value;
                      setData(newData);
                    }}
                    placeholder="Enter Operator"
                    list='employee'
                  />
                  <datalist id="employee">
                    <option></option>
                    {employees.map(x => {
                      return <option key={x.Emp_ID}>{x.Name}</option>
                    })}
                  </datalist>
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={row.Status}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].Status = e.target.value;
                      setData(newData);
                      for (var i = 0; i < row.subParts.length; i++) {
                        const newData = [...data];
                        newData[index].subParts[i].subStatus = e.target.value;
                        setData(newData);
                      }
                    }}
                    placeholder="Enter Status"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    value={row.Scrap}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].Scrap = e.target.value;
                      setData(newData);
                      for (var i = 0; i < row.subParts.length; i++) {
                        const newData = [...data];
                        newData[index].subParts[i].subScrap = e.target.value;
                        setData(newData);
                      }
                    }}
                    placeholder="Enter Scrap"

                  />
                </td><td>
                  <input
                    type="text"
                    className="form-control"
                    value={row.Remarks}
                    onChange={(e) => {
                      const newData = [...data];
                      newData[index].Remarks = e.target.value;
                      setData(newData);
                      for (var i = 0; i < row.subParts.length; i++) {
                        const newData = [...data];
                        newData[index].subParts[i].subRemarks = e.target.value;
                        setData(newData);
                      }
                    }}
                    placeholder="Enter Remarks"

                  />
                </td>
                <td>
                  <button className="btn btn-primary" onClick={() => handleMoreCut(index)}>
                    More Cut
                  </button>
                </td>
              </tr>
              {row.subParts && row.subParts.map((sub, subIndex) => (
                <tr key={`${index}-sub-${subIndex}`} className="subpart-row">
                  {/* Sheet ID - read-only */}
                  <td hidden>{row.SheetID || "Auto-Generated"}</td>

                  {/* Item No - read-only */}
                  <td hidden>
                    <input
                      type="text"
                      className="form-control"
                      value={row.ItemNo}
                      placeholder="Enter Item No"
                      readOnly
                    />
                  </td>

                  {/* Lot No - read-only */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      Value={row.LotNo}
                      placeholder="Enter Lot No"
                      readOnly
                    />
                  </td>

                  {/* Chair Part Type - read-only */}
                  <td hidden>
                    <input
                      type="text"
                      className="form-control"
                      value={row.ChairPartType}
                      placeholder="Enter Chair Part Type"
                      readOnly
                    />
                  </td>

                  {/* Part Number - read-only */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={sub.Sub_Part_Name}
                      placeholder="Select Part No"
                      readOnly
                    />
                  </td>

                  {/* Dimensions - read-only */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={row.Dimensions}
                      placeholder="Enter Dimensions"
                      readOnly
                    />
                  </td>

                  {/* Quantity - editable */}
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      Value={sub.subQTY}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].subParts[subIndex].subQTY = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Enter Quantity"
                    />
                  </td>

                  {/* Cut Date - read-only */}
                  <td>
                    <input
                      type="date"
                      className="form-control"
                      value={row.CutDate}
                      readOnly
                    />
                  </td>

                  {/* Operator - read-only */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={row.Operator}
                      placeholder="Enter Operator"
                      readOnly
                    />
                  </td>

                  {/* Status - editable */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      Value={row.Status}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].subParts[subIndex].subStatus = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Enter Status"
                    />
                  </td>

                  {/* Scrap - editable */}
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      Value={row.Scrap}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].subParts[subIndex].subScrap = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Enter Scrap"
                    />
                  </td>

                  {/* Remarks - editable */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      Value={row.Remarks}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].subParts[subIndex].subRemarks = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Enter Remarks"
                    />
                  </td>

                  {/* Actions (if needed) */}
                  <td>
                    {/*  <button className="btn btn-primary" onClick={() => handleMoreCut(index)}>
                      More Cut
                    </button> */}
                  </td>
                </tr>

              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      <button onClick={submitdata} class="btn btn-primary">Submit</button>
      {isLoading ?
        <div className='overlay'>
          <div className="loading-container">
            <div className="loading-dots">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
            <p className='loading'>Submitting</p>
          </div>

        </div> : null}
    </div>
  )
}

export default New_cut;